import checkIcon from "@/assets/icons/question-rail-check.svg";
import flaggedIcon from "@/assets/icons/question-rail-flagged.svg";
import incorrectIcon from "@/assets/icons/question-rail-incorrect.svg";

interface QuestionRailStatusProps {
  correct?: boolean;
  flagged: boolean;
  showAnswer: boolean;
}

export function QuestionRailStatus({
  correct,
  flagged,
  showAnswer,
}: QuestionRailStatusProps) {
  if (flagged) {
    return <img alt="" aria-hidden="true" className="h-4 w-4 shrink-0" src={flaggedIcon} />;
  }
  if (!showAnswer) return null;

  return correct ? (
    <img alt="" aria-hidden="true" className="h-5 w-5 shrink-0" src={checkIcon} />
  ) : (
    <img alt="" aria-hidden="true" className="h-5 w-5 shrink-0" src={incorrectIcon} />
  );
}
